<template>
  <DetailTemplate
    :custom-class="'claim-detail detail-page'"
    v-if="getPermission('claim:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0 flex-wrap align-center">
          <!-- <Status :status="customerActivated"></Status> -->
          <template v-if="detail && detail.status">
            <span class="my-1">
              <CustomStatus
                v-if="false"
                :status="detail.status"
                endpoint="claim/status"
              ></CustomStatus>
            </span>
            <!-- <pre>{{ detail.status }}</pre> -->
            <span v-if="detail?.status">
              <v-chip
                label
                :color="detail.status_color"
                text-color="white"
                class="font-weight-500"
              >
                {{ detail.status_text }}
              </v-chip>
            </span>
          </template>
        </div>

        <div>
          <span
            class="font-weight-bold color-custom-blue font-size-21 ml-2 my-1"
            >{{ formatMoney(detail.receipt_amount) }}</span
          >
        </div>
        <div class="mt-5 px-0">
          <table width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Claim Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                colspan="2"
              >
                <EntityAlert
                  v-if="detail?.entity_relation?.name"
                  :name="detail.entity_relation.name"
                />
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Claim #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <v-chip
                  label
                  color="chip-custom-blue"
                  outlined
                  class="text-white p-3"
                  small
                  >{{ detail.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Title
              </td>
              <td valign="middle" class="py-1 font-size-18 text-capitalize">
                <label class="m-0" v-if="detail.title">{{
                  detail.title
                }}</label>
                <em class="text-muted" v-else> title</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Job Type
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <v-chip
                  v-if="detail.job_type"
                  small
                  label
                  outlined
                  :color="Number(detail.job_type) === 1 ? 'cyan' : 'green'"
                  class="font-weight-medium"
                >
                  {{
                    Number(detail.job_type) === 1
                      ? "Project Job"
                      : Number(detail.job_type) === 2
                      ? "Service Contract Job"
                      : "—"
                  }}
                </v-chip>

                <em v-else class="text-muted">No job type</em>
              </td>
            </tr>
            <tr v-if="detail.added_at">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Created
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">
                  {{ formatDate(detail.added_at) }}
                </label>
              </td>
            </tr>
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Approver Information
              </th>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Choose Approver
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.approver?.display_name">
                  {{ detail.approver.display_name }}
                </label>

                <em class="text-muted" v-else>No Choose Approver</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Email
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.approver?.user_email">
                  {{ detail?.approver?.user_email || "No Email" }}
                </label>

                <em class="text-muted" v-else>no email </em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Phone Number
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.approver?.phone_number">
                  {{ detail.approver?.phone_number || "—" }}
                </label>

                <em class="text-muted" v-else>no phone number </em>
              </td>
            </tr>
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Employee Information
              </th>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Employee
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.employee?.display_name">
                  {{ detail.employee.display_name }}
                </label>

                <em class="text-muted" v-else>No Employee Selected</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Email
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.employee?.primary_email">
                  {{ detail?.employee?.primary_email || "No Email" }}
                </label>

                <em class="text-muted" v-else>no email </em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Phone Number
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="detail.employee?.primary_phone">
                  {{ detail.employee?.primary_phone || "—" }}
                </label>

                <em class="text-muted" v-else>no phone number </em>
              </td>
            </tr>

            <template v-if="detail.project_details">
              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
                >
                  Project Information
                </th>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Project Barcode
                </td>

                <td valign="middle" class="py-1 font-size-18">
                  <v-chip
                    v-if="
                      detail.project_details && detail.project_details.barcode
                    "
                    label
                    color="chip-custom-blue"
                    outlined
                    class="text-white p-3"
                    small
                    :to="
                      getDefaultRoute('project.detail', {
                        params: {
                          id: detail.project_details.id,
                        },
                      })
                    "
                  >
                    {{ detail.project_details.barcode }}
                  </v-chip>

                  <em v-else class="text-muted">No barcode</em>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Project Name
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.project_details.name">
                    {{ detail.project_details.name }}
                  </label>
                  <em class="text-muted" v-else>No project</em>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Reference
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.project_details.reference">
                    {{ detail.project_details.reference }}
                  </label>
                  <em class="text-muted" v-else>No project</em>
                </td>
              </tr>
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Start Date
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.project_details.started_at">
                    {{ detail.project_details.started_at }}
                  </label>
                  <em class="text-muted" v-else>No start date</em>
                </td>
              </tr>

              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  End Date
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.project_details.deadline">
                    {{ detail.project_details.deadline }}
                  </label>
                  <em class="text-muted" v-else>No end date</em>
                </td>
              </tr>
            </template>
            <template v-if="detail && detail.visit_details">
              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
                >
                  Visit Information
                </th>
              </tr>

              <!-- Visit Barcode -->
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Visit Barcode
                </td>

                <td valign="middle" class="py-1 font-size-18">
                  <v-chip
                    v-if="
                      detail.visit_details &&
                      detail.visit_details.id &&
                      detail.visit_details.barcode
                    "
                    label
                    color="chip-custom-blue"
                    outlined
                    class="text-white p-3"
                    small
                    :to="
                      getDefaultRoute('visit.detail', {
                        params: {
                          id: detail.visit_details.id,
                        },
                      })
                    "
                  >
                    {{ detail.visit_details.barcode }}
                  </v-chip>

                  <em v-else class="text-muted">No barcode</em>
                </td>
              </tr>
              <!-- Visit Title -->
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Visit Name
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.visit_details.title">
                    {{ detail.visit_details.title }}
                  </label>
                  <em class="text-muted" v-else>No visit name</em>
                </td>
              </tr>

              <!-- Visit Status -->
              <!-- <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Visit Status
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.visit_details.status_text">
                    {{ detail.visit_details.status_text }}
                  </label>
                  <em class="text-muted" v-else>No status</em>
                </td>
              </tr> -->

              <!-- Property Name -->
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Property Name
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label
                    class="m-0"
                    v-if="
                      detail.visit_details.property &&
                      detail.visit_details.property.property_name
                    "
                  >
                    {{ detail.visit_details.property.property_name }}
                  </label>
                  <em class="text-muted" v-else>No property name</em>
                </td>
              </tr>

              <!-- Property Address -->
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Property Address
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label
                    class="m-0"
                    v-if="
                      detail.visit_details.property &&
                      detail.visit_details.property.property_address
                    "
                  >
                    {{ detail.visit_details.property.property_address }}
                  </label>
                  <em class="text-muted" v-else>No property address</em>
                </td>
              </tr>

              <!-- Contact Person -->
              <tr>
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Contact Person
                </td>

                <td valign="middle" class="py-1 font-size-18">
                  <div v-if="detail.visit_details.contact_person_details">
                    <div>
                      <v-icon small class="mr-2">mdi-account-outline</v-icon>
                      {{
                        detail.visit_details.contact_person_details.name ||
                        "no name"
                      }}
                    </div>

                    <div>
                      <v-icon small class="mr-2">mdi-email-outline</v-icon>
                      {{
                        detail.visit_details.contact_person_details.email ||
                        "no email"
                      }}
                    </div>

                    <div>
                      <v-icon small class="mr-2">mdi-phone-outline</v-icon>
                      {{
                        detail.visit_details.contact_person_details.phone ||
                        "no phone"
                      }}
                    </div>
                  </div>

                  <em class="text-muted" v-else>No contact person</em>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-card>
    </template>

    <template v-slot:header-title>
      <h1
        v-if="pageLoaded || detail.status"
        class="form-title text-capitalize mr-2 font-weight-600"
      >
        {{ detail.title }}
      </h1>
    </template>
    <template v-slot:header-action>
      <div
        class="d-flex align-center justify-end"
        v-if="pageLoaded || detail.status"
      >
        <template v-if="false && detail.status == 1">
          <v-tooltip top content-class="custom-top-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="statusLoading"
                ED
                class="mx-2 custom-bold-button white--text"
                color="cyan"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-check</v-icon> Approve
              </v-btn>
            </template>
            <span>Click here to Approve</span>
          </v-tooltip>
        </template>
        <template v-if="false && detail.status == 1 && userDetails.role == 4">
          <v-tooltip top content-class="custom-top-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="statusLoading"
                class="mx-2 custom-bold-button white--text"
                color="red"
                v-bind="attrs"
                v-on="on"
                v-on:click="updateMoreAction('mark_as_rejected')"
              >
                <v-icon left>mdi-close </v-icon> Reject
              </v-btn>
            </template>
            <span>Click here to Reject</span>
          </v-tooltip>
        </template>

        <template v-if="detail.status == 1 && userDetails.role != 2">
          <v-tooltip bottom content-class="custom-bottom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="Number(detail?.status) === 1"
                depressed
                :disabled="statusLoading"
                class="mx-1 custom-bold-button white--text"
                color="cyan"
                @click="updateMoreAction('edit')"
              >
                <v-icon left>mdi-pencil</v-icon>
                Edit
              </v-btn>
            </template>
            <span>Click here to edit Quote</span>
          </v-tooltip>
        </template>

        <v-menu
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
          left
          style="z-index: 99 !important"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              :disabled="statusLoading"
              class="mx-1 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
              v-if="detail.status < 2 && userDetails.role != 2"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <template v-for="(more, index) in moreActions">
              <v-list-item
                link
                :key="index"
                @click="updateMoreAction(more.action)"
                :disabled="
                  statusLoading ||
                  more.disabled ||
                  ([
                    'mark_as_approved',
                    'mark_as_rejected',
                    'mark_as_cancelled',
                  ].includes(more.action) &&
                    userDetails.id !== detail.approver?.id &&
                    Number(userDetails.role) !== 1 &&
                    Number(userDetails.is_main_admin || 0) !== 1)
                "
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="font-weight-500 font-size-14">
                  {{ more.title }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <v-btn
          depressed
          class="mx-1 custom-grey-border custom-bold-button"
          v-on:click="goBack()"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll claim-detail-height"
        style="position: relative"
      >
        <v-container fluid v-if="pageLoaded">
          <v-row v-if="pageLoaded">
            <v-col md="12">
              <v-tabs
                active-class="custom-tab-active"
                v-model="claimTab"
                background-color="transparent"
                color="cyan"
                class="custom-tab-transparent tab-sticky"
              >
                <v-tab class="font-size-16 font-weight-600 px-8" href="#other">
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="$assetURL('media/custom-svg/property.svg')"
                    />
                    <!--end::Svg Icon-->
                  </span>
                  Overview
                </v-tab>
                <v-tab
                  class="font-size-16 font-weight-600 px-8"
                  href="#attachments"
                >
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <inline-svg
                      :src="$assetURL('media/custom-svg/attachment.svg')"
                    />
                  </span>
                  Attachments
                </v-tab>
                <v-tab
                  class="font-size-16 font-weight-600 px-8"
                  href="#history"
                >
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <inline-svg
                      :src="$assetURL('media/custom-svg/history.svg')"
                    />
                  </span>
                  History
                </v-tab>
                <v-tab
                  class="font-size-16 font-weight-600 px-8"
                  href="#pdfHistory"
                  v-if="false"
                >
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <inline-svg
                      :src="$assetURL('media/custom-svg/history.svg')"
                    />
                  </span>
                  PDF History
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="claimTab">
                <v-tab-item value="other">
                  <v-container fluid>
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                    >
                      <v-card-title class="headline grey lighten-4 py-1">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                        >
                          CATEGORY INFORMATION</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <!-- <span class="color-custom-blue font-weight-700 font-size-19">
                      <router-link
                      :to="
                        getDefaultRoute('customer.detail', {
                          params: {
                            id: detail.customer.id,
                          },
                        })
                      "
                      >{{ detail.customer.display_name }}
                       </router-link>
                             </span> -->
                        <v-layout class="my-4">
                          <v-flex md6 class="mr-2">
                            <table width="100%">
                              <tr>
                                <!-- <td class="font-weight-600">
                                  <span
                                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                                  >
                                    Category Detail</span
                                  >
                                </td> -->
                              </tr>
                              <tr>
                                <template>
                                  <tr>
                                    <td
                                      valign="middle"
                                      class="py-1 pr-9 font-size-18 font-weight-500"
                                    >
                                      Claim Categories
                                    </td>
                                    <td align="center">:</td>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18"
                                    >
                                      <label class="m-0">
                                        <template v-if="detail.claim_category">
                                          {{ detail.claim_category }}</template
                                        >
                                        <em v-else class="text-muted">
                                          no claim category</em
                                        >
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18 font-weight-500"
                                    >
                                      Sub Categories
                                    </td>
                                    <td align="center">:</td>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18"
                                    >
                                      <label class="m-0">
                                        <template
                                          v-if="detail.claim_sub_category"
                                        >
                                          {{ detail.claim_sub_category }}
                                        </template>
                                        <em v-else class="text-muted">
                                          no sub category</em
                                        >
                                      </label>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18 font-weight-500"
                                    >
                                      Category Total Amount
                                    </td>
                                    <td align="center">:</td>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18"
                                    >
                                      <label class="m-0">
                                        <template
                                          v-if="
                                            detail.category_details.max_amount
                                          "
                                        >
                                          {{
                                            formatMoney(
                                              detail.category_details.max_amount
                                            )
                                          }}</template
                                        >
                                        <em v-else class="text-muted">
                                          no category total amount</em
                                        >
                                      </label>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18 font-weight-500"
                                    >
                                      Receipt Amount
                                    </td>
                                    <td align="center">:</td>
                                    <td
                                      valign="middle"
                                      class="py-1 font-size-18"
                                    >
                                      <label class="m-0">
                                        <template v-if="detail.receipt_amount">
                                          {{
                                            formatMoney(detail.receipt_amount)
                                          }}</template
                                        >
                                        <em v-else class="text-muted">
                                          no receipt amount</em
                                        >
                                      </label>
                                    </td>
                                  </tr>
                                </template>
                              </tr>
                            </table>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                    <v-card
                      v-if="detail && detail.description"
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                    >
                      <v-card-title class="headline grey lighten-4 py-1">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >DESCRIPTION</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <div
                          class="w-100 custom-grey-border p-4"
                          v-if="detail && detail.description"
                        >
                          <read-more
                            class=""
                            v-if="detail && detail.description"
                            more-str="read more"
                            :text="
                              detail.description || '<em>No Description</em>'
                            "
                            link="#"
                            less-str="read less"
                            :max-chars="200"
                          >
                          </read-more>
                        </div>
                        <div v-else>
                          <em class="text-muted"> no description </em>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                      v-if="[2, 3, 4, 5].includes(detail.status)"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                        >
                          {{ get_remark_title() }}
                        </span>
                      </v-card-title>

                      <v-card-text class="p-6 font-size-16">
                        <div class="w-100 custom-grey-border p-4">
                          <read-more
                            more-str="read more"
                            :text="
                              get_remark_value() || `No ${get_remark_title()}`
                            "
                            link="#"
                            less-str="read less"
                            :max-chars="200"
                          />
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      v-if="detail && detail.resion"
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                    >
                      <v-card-title class="headline grey lighten-4 py-1">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >Reason</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <v-card-text class="p-6 font-size-16">
                          <div
                            class="w-100 custom-grey-border p-4"
                            v-if="detail && detail.resion"
                          >
                            <read-more
                              class=""
                              v-if="detail && detail.resion"
                              more-str="read more"
                              :text="detail.resion || '<em>No Description</em>'"
                              link="#"
                              less-str="read less"
                              :max-chars="200"
                            >
                            </read-more>
                          </div>
                          <div v-else>
                            <em class="text-muted"> no Reason </em>
                          </div>
                        </v-card-text>
                      </v-card-text>
                    </v-card>
                  </v-container>
                </v-tab-item>
                <v-tab-item value="attachments">
                  <AdditionalDocuments
                    :type-id="detail.id"
                    class="mx-4"
                    type-text="Claim Attachments"
                    :type="28"
                    :extensive="false"
                  >
                  </AdditionalDocuments>
                </v-tab-item>
                <v-tab-item :value="'history'">
                  <InternalHistoryDetail
                    v-if="detail?.id"
                    type="claim"
                    :type_id="detail.id"
                  />
                </v-tab-item>
                <v-tab-item :value="'pdfHistory'">
                  <PDFHistoryDetail
                    type="claim"
                    :type_id="detail.id"
                    v-on:success="getClaim()"
                  >
                  </PDFHistoryDetail>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </perfect-scrollbar>
      <!-- <SendMail
        :mail-dialog="mail_dialog"
        title="Send as Email"
        type="quotation"
        v-on:close="mail_dialog = false"
        :type-id="claimId"
        v-on:success="getClaim()"
      ></SendMail> -->
      <Dialog :common-dialog="confirm_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Confirmation </template>
        <template v-slot:body>
          <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
            <v-container class="px-10" fluid>
              <!-- Confirmation message -->
              <p
                class="font-weight-600 font-size-19"
                v-if="confirm_type != 'mark_as_send'"
              >
                Are you sure, you want to
                <span class="font-weight-700">{{ get_confirm_title() }}</span
                >?
              </p>
              <p v-else class="font-weight-600 font-size-19">
                Are you sure you have
                <span class="font-weight-700"
                  >send out the ..... already to customer</span
                >?
              </p>

              <!-- Remark field - Required for Reject and Cancelled, Optional for Approve -->
              <v-layout
                class="my-4"
                v-if="
                  confirm_type == 'mark_as_rejected' ||
                  confirm_type == 'mark_as_cancelled' ||
                  confirm_type == 'mark_as_approved'
                "
              >
                <v-flex>
                  <label
                    class="font-weight-500 font-size-16"
                    :class="{
                      required:
                        confirm_type == 'mark_as_rejected' ||
                        confirm_type == 'mark_as_cancelled',
                    }"
                  >
                    Remark
                    <span
                      v-if="
                        confirm_type == 'mark_as_rejected' ||
                        confirm_type == 'mark_as_cancelled'
                      "
                      class="red--text"
                      >*</span
                    >
                  </label>
                  <TextAreaField
                    :rules="getRemarkRules()"
                    auto-grow
                    dense
                    filled
                    color="cyan"
                    v-model="actionData.remark"
                    :placeholder="
                      confirm_type == 'mark_as_approved'
                        ? 'Enter your remark (optional)'
                        : 'Enter your remark'
                    "
                    solo
                    flat
                    row-height="25"
                    counter="200"
                  />
                </v-flex>
              </v-layout>

              <!-- Attachment field -->
              <!-- <v-layout
                class="mt-4"
                v-if="
                  confirm_type == 'mark_as_rejected' ||
                  confirm_type == 'mark_as_cancelled' ||
                  confirm_type == 'mark_as_approved' ||
                  confirm_type == 'mark_as_closed'
                "
              >
                <v-flex md12>
                  <label class="font-weight-500 font-size-16"
                    >Attachment (Optional)</label
                  >

                  <file-upload v-model="actionData.attachments" :maxLimit="5">
                  </file-upload>
                </v-flex>
              </v-layout> -->
            </v-container>
          </v-form>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="confirm_loading"
            v-on:click="confirm_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            NO! CLOSE
          </v-btn>
          <v-btn
            depressed
            v-on:click="confirm_submit()"
            :disabled="!formValid || confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            YES! CONTINUE
          </v-btn>
        </template>
      </Dialog>
      <Dialog :common-dialog="visit_count_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Visit Id Listing On Same Quotation </template>
        <template v-slot:body>
          <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
            <v-container class="px-10" fluid>
              <div class="font-weight-600 font-size-19">
                <!--    {{detail.ticket_multiple}} -->
                <table>
                  <th>Visit #</th>
                  <th>Date</th>
                  <!-- <th>Date</th> -->
                  <tr>
                    <td>
                      <template v-for="(row, index) in detail.ticket_multiple">
                        <span :key="index">
                          <v-chip
                            label
                            :color="getColor(row.visit[0].status_text)"
                            class="text-white p-2 mb-2"
                            small
                          >
                            {{ row.visit[0].barcode }}
                          </v-chip>
                          <br />
                        </span>
                      </template>
                    </td>
                    <td>
                      <template v-for="(row, index) in detail.ticket_multiple">
                        <span :key="index">
                          <v-chip
                            v-if="row && row.visit && row.visit[0]"
                            label
                            color="cyan"
                            class="text-white p-2 mb-2"
                            small
                          >
                            {{ formatDate(row.visit[0].finished_at, "") }}
                          </v-chip>
                          <br />
                        </span>
                      </template>
                    </td>
                    <!-- <td>
                        <template v-for="(row, index) in detail.ticket_multiple">
                          <span :key="index">
                            <v-chip v-if="row && row.visit && row.visit[0] && row.visit[0].teams && row.visit[0].teams.barcode" label color="cyan" class="text-white p-2" small>
                              {{row.visit[0].teams.barcode}}
                            </v-chip>
                          </span>
                        </template>
                      </td> -->
                  </tr>
                  <!--  <tr>
                  
                      <template v-for="(row, index) in detail.ticket_multiple">
                        
                        <span :key="index">
                          <v-chip v-if="row && row.visit && row.visit[0] && row.visit[0].teams && row.visit[0].teams.team_name" label color="cyan" class="text-white p-2 ml-2 mb-2" small>
                            {{ row.visit[0].teams.team_name}}
                          </v-chip>

                        </span>
                      </template>
                  
                 </tr> -->
                </table>
              </div>
            </v-container>
          </v-form>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="confirm_loading"
            v-on:click="visit_count_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            No! Close
          </v-btn>
          <v-btn
            v-on:click="(confirm = true), pushToVisit()"
            :disabled="!formValid || confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Yes! Continue
          </v-btn>
        </template>
      </Dialog>
      <Dialog :common-dialog="download_dialog" :dialog-width="dialogWidth">
        <template v-slot:title> Download Quotation </template>
        <template v-slot:body>
          <v-container class="px-10" fluid>
            <v-col md="12">
              <v-autocomplete
                dense
                color="cyan"
                filled
                id="prepared-by"
                :items="templateList"
                :disabled="pageLoading"
                :loading="pageLoading"
                v-model.trim="download_template"
                label="Download Template"
                solo
                flat
                item-color="cyan"
                item-text="title"
                item-value="value"
                hide-details
                v-on:change="updatePreparedBy()"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="'No Template Found.'"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col md="12" v-if="download_template == 'HYC_Pn_Inst'">
              <label class="font-weight-700 font-size-16"
                >Installation Clause</label
              >
              <!-- <v-textarea
                  auto-grow
                  dense
                  filled
                  flat
                  v-model="profeinstaservice.profe_insta_service"
                  label="Professional Services and Installation Services"
                  solo
                  color="cyan"
                  hide-details
                  row-height="10"
                  
                ></v-textarea> -->
              <editor
                :disabled="formLoading"
                v-model="profeinstaservice.profe_insta_service"
              />
            </v-col>
            <v-col>
              <label class="font-weight-700 font-size-16">Download Date</label>
              <v-menu
                v-model="DatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    filled
                    flat
                    label="Download Date"
                    hide-details
                    solo
                    :rules="[
                      validateRules.required(download_date, 'Download Date'),
                    ]"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="formattedDownloadDate"
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="download_date"
                  color="cyan"
                  :min="todayDate"
                  v-on:input="DatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <label class="font-weight-700 font-size-16">Valid Till</label>
              <v-menu
                v-model="ValidDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    filled
                    flat
                    label="Valid Till"
                    hide-details
                    solo
                    :rules="[validateRules.required(valid_till, 'Valid Till')]"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="formattedValidDate"
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="valid_till"
                  color="cyan"
                  :min="todayDate"
                  v-on:input="ValidDatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="confirm_loading"
            v-on:click="download_dialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            Close
          </v-btn>
          <v-btn
            v-on:click="download_submit()"
            :disabled="confirm_loading"
            :loading="confirm_loading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Download
          </v-btn>
        </template>
      </Dialog>
      <DeleteDialog :delete-dialog="deleteQuotationDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3 class="font-size-16 font-weight-500 delete-text">
            Once you delete
            <span class="font-weight-700">{{ detail.barcode }}</span
            >, you won't be able to retrieve this later.<br />Are you sure you
            want to delete
            <span class="font-weight-700">{{ detail.barcode }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteQuotationLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteQuotationDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            depressed
            :disabled="deleteQuotationLoading"
            :loading="deleteQuotationLoading"
            color="red lighten-1 white--text"
            v-on:click="deleteQuotationConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Delete</v-btn
          >
        </template>
      </DeleteDialog>
      <Dialog :commonDialog="typeConfirmDialog">
        <template v-slot:title>Confirmation</template>
        <template v-slot:body>
          <v-container fluid class="py-0">
            <v-row>
              <v-col lg="12">
                <RadioInputCustom
                  v-model="jobType"
                  row
                  color="blue darken-4"
                  :items="[
                    {
                      label: 'Adhoc Job',
                      value: 'one-off',
                    },
                    {
                      label: `Recurring Job`,
                      value: 'recurring',
                    },
                  ]"
                ></RadioInputCustom>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button white--text"
            color="cyan"
            v-on:click="pushToVisit()"
          >
            Continue
          </v-btn>
          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="typeConfirmDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>
      <FullDialog
        v-if="notesDialog"
        :dialog="notesDialog"
        content-class="testdata"
      >
        <template v-slot:title
          >{{ detail.title }}(
          {{ detail.barcode }}
          ) Notes
          <CustomStatus
            :status="detail.status"
            endpoint="claim/status"
          ></CustomStatus>

          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red darken-4"
            depressed
            tile
            v-on:click="notesDialog = false"
          >
            Close
          </v-btn>
        </template>
        <template v-slot:body>
          <ChatNote
            v-if="notesDialog"
            :relatedId="claimId"
            :relatedType="'quotation'"
            :documentTypes="32"
            create-url="quotation-notes"
            get-url="quotation-notes"
          ></ChatNote>
        </template>
        <!-- <template v-slot:action>
				<v-btn class="text-white" color="red darken-4" depressed tile v-on:click="closeDialog">
					Close
				</v-btn>
			</template> -->
      </FullDialog>
      <div class="floating-btn-wrapper">
        <div class="position-relative">
          <div
            class="call-btn-underlay"
            style="background-color: rgb(43, 149, 105)"
          ></div>
          <v-icon
            style="font-size: 50px !important"
            color="green"
            small
            v-on:click="notesDialog = true"
            >mdi-chat
          </v-icon>
        </div>
      </div>
    </template>
  </DetailTemplate>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import ChatNote from "@/view/pages/partials/ChatNote";
import FullDialog from "@/view/components/FullDialog";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
// import SendMail from "@/view/pages/partials/Send-Mail";
import {
  GET,
  /* QUERY, */ PATCH,
  DELETE /* PUT*/,
} from "@/core/services/store/request.module";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import PDFHistoryDetail from "@/view/pages/partials/Detail/PDF-History-Detail.vue";
import JwtService from "@/core/services/jwt.service";
import Dialog from "@/view/pages/partials/Dialog";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
// import FileUpload from "@/view/components/app-component/FileInput";
import moment from "moment-timezone";
import AppConfiguration from "@/core/config/app.config";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import RadioInputCustom from "@/view/components/RadioInputCustom.vue";
import EntityAlert from "@/view/components/ShowEntityName.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  data() {
    return {
      notesDialog: false,
      jobType: "one-off",
      typeConfirmDialog: false,
      formLoading: false,
      tab: null,
      claimId: 0,
      pageLoaded: false,
      statusLoading: false,
      mail_dialog: false,
      deleteQuotationDialog: false,
      pageLoading: false,
      todayDate: null,
      DatePicker: false,
      deleteQuotationLoading: false,
      ValidDatePicker: false,
      confirm_loading: false,
      visit_count_dialog: false,
      download_template: "HYC_Pn_Inst",
      download_dialog: false,
      confirm_dialog: false,
      download_date: moment().format("YYYY-MM-DD"),
      valid_till: moment().add(14, "days").format("YYYY-MM-DD"),
      confirm_type: null,

      moreActions: [],
      detail: {},
      db_approval: {},

      confirm: false,
      templateList: [],
      actionData: {
        remark: null,
        attachments: [],
        status: null,
      },
      userDetails: new Object(),
      attachments: [],
      profeinstaservice: {
        profe_insta_service: null,
        quotation: null,
      },
    };
  },
  methods: {
    getTypeAtt(quotationType, type) {
      const typeMap = {
        1: { text: "Modernization", color: "red darken-3" },
        2: { text: "Ad-Hoc", color: "info darken-4" },
        3: { text: "Maintenance", color: "light-green darken-3" },
      };

      const entry = typeMap[quotationType];
      if (!entry) return "";

      return type === "text" ? entry.text : entry.color;
    },

    getDueDay(day) {
      if (day == 2) {
        return 15;
      } else if (day == 3) {
        return 30;
      } else if (day == 4) {
        return 45;
      }
    },
    updateAttachment(param) {
      this.attachments = param;
    },
    lengthCount(param) {
      this.itemCount = param;
    },
    viewEnquiry(id) {
      this.$router.push(
        this.getDefaultRoute("enquiry.detail", {
          params: { id: id },
        })
      );
    },
    pageReload() {
      window.location.reload();
    },
    deleteVisit() {
      this.deleteQuotationDialog = true;
    },
    deleteQuotationConfirm() {
      this.deleteQuotationLoading = true;
      this.$store
        .dispatch(DELETE, { url: `quotation/${this.detail.id}` })
        .then(() => {
          this.deleteQuotationDialog = false;
          this.$nextTick(() => {
            this.$router.push(this.getDefaultRoute("quotation"));
          });
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteQuotationLoading = false;
        });
    },
    getValidityDate(days) {
      if (this.detail.added_at) {
        let date = moment(this.detail.added_at, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        let validity = moment(date, "YYYY-MM-DD")
          .add(days, "days")
          .format("YYYY-MM-DD");
        return this.formatDate(validity);
      }
    },
    refressData() {
      this.getClaim();
    },
    get_confirm_title() {
      if (this.confirm_type == "mark_as_closed") {
        return "Mark as Closed";
      } else if (this.confirm_type == "mark_as_cancelled") {
        return "Mark as Cancelled";
      } else if (this.confirm_type == "mark_as_pending") {
        return "Mark as Pending";
      } else if (this.confirm_type == "mark_as_rejected") {
        return "Mark as Rejected";
      } else if (this.confirm_type == "mark_as_accepted") {
        return "Mark as Accepted";
      } else if (this.confirm_type == "mark_as_approved") {
        return "Mark as Approve";
      } else if (this.confirm_type == "mark_as_send") {
        return "Send Quotation";
      } else if (this.confirm_type == "mark_as_unapproved") {
        return "Unapprove";
      }
    },
    getColor(data) {
      if (data == "Open") {
        return "blue";
      } else if (data == "In-Progress") {
        return "yellow";
      } else if (data == "Hold") {
        return "red";
      } else if (data == "Completed") {
        return "green";
      } else if (data == "Cancelled") {
        return "red";
      } else if (data == "Hold & Unassigned") {
        return "cyan";
      }
    },
    getColorType(data) {
      if (data == 1) {
        return "green darken-3";
      } else if (data == 2) {
        return "orange darken-3";
      } else if (data == 3) {
        return "red darken-3";
      }
    },
    getColorText(data) {
      if (data == 1) {
        return "New";
      } else if (data == 2) {
        return "Maintenance";
      } else if (data == 3) {
        return "General";
      }
    },
    routeToVisit(id) {
      this.$router.push({
        name: "admin.visit.detail",
        params: { id },
      });
    },

    confirm_submit() {
      const _this = this;
      const validateStatus = _this.$refs.statusForm.validate();
      const formErrors = _this.validateForm(_this.$refs.statusForm);
      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }
      if (!validateStatus) {
        return false;
      }
      _this.confirm_loading = true;
      if (this.confirm_type === "mark_as_closed") {
        this.actionData.remark = "Closed";
      }
      switch (this.confirm_type) {
        case "mark_as_cancelled":
          this.updateStatus(4);
          break;

        case "mark_as_closed":
          this.updateStatus(5);
          break;

        case "mark_as_rejected":
          this.updateStatus(3);
          break;

        case "mark_as_approved":
          this.updateStatus(2);
          break;

        case "submit_for_approval":
          this.updateStatus(2);
          break;
      }
    },
    async download_submit() {
      if (this.download_template && this.download_dialog) {
        await this.ProfesnalInstaService();
      }
    },

    updateMoreAction(type) {
      switch (type) {
        case "edit":
          this.editclaim();
          break;
        case "submit_for_approval":
          this.confirm_type = type;
          this.confirm_dialog = true;
          break;
        case "mark_as_approved":
          this.confirm_type = type;
          this.confirm_dialog = true;
          break;
        case "mark_as_rejected":
          this.confirm_type = type;
          this.confirm_dialog = true;
          break;
        case "mark_as_paid":
          this.updateStatus(6);
          break;
        case "re_submit":
          this.updateStatus(1);
          break;
        case "download_pdf":
          this.downloadPDF();
          break;
        case "mark_as_cancelled":
        case "mark_as_closed":
          this.confirm_type = type;
          this.confirm_dialog = true;
          break;

        default:
          console.warn("Action not implemented:", type);
      }
    },

    getRemarkRules() {
      if (
        this.confirm_type === "mark_as_rejected" ||
        this.confirm_type === "mark_as_cancelled"
      ) {
        return [this.validateRules.required(this.actionData.remark, "Remark")];
      }
      return [];
    },

    updateStatus(status) {
      if (this.statusLoading) {
        return false;
      }
      /*   this.actionData.attachments = this.attachments; */
      this.actionData.status = status;
      this.statusLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "claim/" + this.claimId + "/status",
          data: this.actionData,
        })
        .then(() => {
          this.getClaim();
          this.confirm_loading = false;
          this.confirm_dialog = false;
          this.confirm_type = null;
          // Reset form data
          this.actionData = {
            remark: null,
            attachments: [],
            status: null,
          };
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.statusLoading = false;
          this.confirm_loading = false;
        });
    },

    routeToJob() {
      this.typeConfirmDialog = true;
    },

    editclaim() {
      this.$router.push(
        this.getDefaultRoute("claim.create", {
          query: { edit: this.detail?.id },
        })
      );
    },
    getClaim() {
      this.$store
        .dispatch(GET, { url: "claim/" + this.claimId })
        .then(({ data }) => {
          this.detail = data;
          this.profeinstaservice.profe_insta_service =
            this.detail.profe_insta_service;
          this.db_approval = data.db_approval;
          this.moreActions = data.more_actions || [];
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "claim", route: "claim" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;
        });
    },

    get_remark_title() {
      if (this.detail.status == 2) {
        return "Approved Remark";
      } else if (this.detail.status == 3) {
        return "Rejected Remark";
      } else if (this.detail.status == 4) {
        return "Cancelled Remark";
      } else if (this.detail.status == 5) {
        return "Closed Remark";
      } else {
        return null;
      }
    },
    get_remark_value() {
      if (this.detail.status == 2) return this.detail.approved_remark;
      if (this.detail.status == 3) return this.detail.rejected_remark;
      if (this.detail.status == 4) return this.detail.cancelled_remark;
      if (this.detail.status == 5) return this.detail.closed_remark;
      return "";
    },
  },
  created() {
    // console.log(this.$route);

    this.claimId = this.lodash.toSafeInteger(this.$route.params.id);
    /*  this.claimTab = this.$route.query.tab; */

    // console.log(this.claimTab, "this.claimTab");

    this.templateList = [
      /* { title: "HYC Pn Rm", value: "HYC_Pn_Rm" },
      { title: "HYC Rm", value: "HYC_Rm" },
      { title: "HYC Rm Inst", value: "HYC_Rm_Inst" }, */
      { title: "HYC Pn Inst", value: "HYC_Pn_Inst" },
      { title: "HYC Pn None", value: "HYC_Pn_None" },
    ];
  },

  mounted() {
    this.getClaim();
    // this.getClaimSetting();
    this.userDetails = JwtService.currentUser();
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
    formattedDownloadDate() {
      let Config = AppConfiguration.get();
      if (Config) {
        return moment(this.download_date).format(Config.dateFormat);
      }
      return this.download_date;
    },
    formattedValidDate() {
      let Config = AppConfiguration.get();
      if (Config) {
        return moment(this.valid_till).format(Config.dateFormat);
      }
      return this.valid_till;
    },
    claimTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.claimTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "other";
      },
    },
  },
  components: {
    CustomStatus,
    DetailTemplate,
    DeleteDialog,
    Dialog,
    AdditionalDocuments,
    RadioInputCustom,
    // "file-upload": FileUpload,
    TextAreaField,
    InternalHistoryDetail,
    PDFHistoryDetail,
    editor: TinyMCE,
    FullDialog,
    ChatNote,
    EntityAlert,
  },
};
</script>
